import React from "react";
import { WordFilter } from "../../../utils/wordFilter/WordFilter";
import NikkiWrapper from "../wrapper/NikkiWrapper";
import "../../../styles/components/selectbook/SelectSteps.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function InputName({
  onNext,
  onPrev,
  name,
  setName,
  onAlert,
  onNextSound,
  onPrevSound,
}) {
  const { t } = useAppTranslation("components/selectbook/inputName");

  const handlePrev = () => {
    onPrevSound?.();
    setName("");
    onPrev();
  };

  const handleNext = () => {
    if (name.trim() === "") {
      onAlert(t("alerts.enterName"));
      return;
    }

    if (WordFilter(name)) {
      onAlert(t("alerts.inappropriateName"));
      return;
    }
    onNextSound?.();
    onNext();
  };

  return (
    <NikkiWrapper
      titleDescription={t("titleDescription")}
      progressValue="55"
      onNext={handleNext}
      onPrev={handlePrev}
      showPrev={true}
      onNextSound={onNextSound}
      onPrevSound={onPrevSound}
    >
      <div className="name-input-box">
        <h3>{t("title")}</h3>
        <p>{t("description")}</p>
        <div className="input-wrap">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("placeholder")}
          />
        </div>
      </div>
    </NikkiWrapper>
  );
}
